function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.44 21.91L8.5 12.8a14.21 14.21 0 01-1.3 3.9l3.51 6.53a1.54 1.54 0 001.37.77 2.13 2.13 0 00.7-.14 1.44 1.44 0 00.69-1.9zM8.8 2.4A2.4 2.4 0 116.4 0a2.4 2.4 0 012.4 2.4"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.14 9.3a10.07 10.07 0 01-3.92-3.77A1.34 1.34 0 005.41 5H5.3a2 2 0 00-.25.18 11.43 11.43 0 00-4.28 6.44 1.46 1.46 0 00.93 1.81 1.35 1.35 0 001.69-.9v-.07a9.79 9.79 0 011.86-3.64 12.74 12.74 0 010 3.8c-.71 4.64-4.78 8.84-4.83 8.9a1.5 1.5 0 000 2.05 1.31 1.31 0 001.92 0c.2-.18 4.81-4.93 5.6-10.49a16.77 16.77 0 00.18-2.24A9.52 9.52 0 0010 12.05a1.24 1.24 0 00.54.11 1.47 1.47 0 001.3-.89 1.52 1.52 0 00-.74-2z"
});

function SvgWalking(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 13.6 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "assets/images/walking.90bb2111.svg";
export { SvgWalking as ReactComponent };